(() => {
  const applyGeneratedLoginRoute = () => {
    const loginUrl = window.CodexCustomerAccount?.loginUrl;
    if (!loginUrl) return;

    document
      .querySelectorAll('a.header__icon--account, .mobile-menu__foot a.mobile-menu__cta')
      .forEach((link) => {
        const href = link.getAttribute('href') || '';

        /* Le thème avait une URL d'authentification codée en dur, qui casse
           dans les previews Shopify. On la remplace par la route calculée
           par Liquid pour le contexte de rendu courant. */
        if (href.includes('/customer_authentication/login')) {
          link.setAttribute('href', loginUrl);
        }
      });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyGeneratedLoginRoute, { once: true });
  } else {
    applyGeneratedLoginRoute();
  }

  /* Le Theme Editor peut reconstruire le header sans recharger la page. */
  document.addEventListener('shopify:section:load', applyGeneratedLoginRoute);
})();
